/**
 * Layout constants shared by the theme and by leaf components. Kept free of
 * imports so a component can read one without loading `theme.tsx` (and the
 * ESM-only `color` package it pulls in).
 */

/**
 * The widest a phone gets on its side, with headroom: they run 850-1000px. The
 * theme lifts `sm` to just above this on a landscape phone.
 */
export const PHONE_LANDSCAPE_MAX_WIDTH = 1099;

/**
 * A phone held sideways. Width alone cannot tell one from a small laptop, so
 * this goes by what only a phone has: a touch-primary pointer and a viewport
 * under 500px tall.
 *
 * The width bounds are for the soft keyboard. On iOS and current Chrome it
 * does not shrink the layout viewport this reads, but in an Android in-app
 * browser or Firefox for Android it does, and a portrait phone or a landscape
 * tablet then drops under 500px tall mid-typing. A portrait phone is never
 * 500px wide, and a tablet in landscape is wider than any phone.
 */
export const PHONE_LANDSCAPE_QUERY = `(hover: none) and (pointer: coarse) and (min-width: 500px) and (max-width: ${PHONE_LANDSCAPE_MAX_WIDTH}px) and (max-height: 500px)`;

/** `PHONE_LANDSCAPE_QUERY` as an `sx` key, for styles that need no hook. */
export const PHONE_LANDSCAPE_MEDIA = `@media ${PHONE_LANDSCAPE_QUERY}`;

/** The top header bar's height, and its height on a phone in landscape. */
export const APP_HEADER_HEIGHT = 64;
export const APP_HEADER_HEIGHT_COMPACT = 48;
